import React, { JSX } from 'react';
import { ServiceId } from '@/@types/application';
import Button from './Button';
import MaintenanceSchedulePosts from './MaintenanceSchedulePosts';
import Section from './Section';
import Title from './Title';

type Props = {
  serviceId: ServiceId;
};

const MaintenanceSchedule: React.FC<Props> = ({ serviceId }): JSX.Element => {
  return (
    <Section>
      <Title text="メンテナンス予定" />
      <MaintenanceSchedulePosts serviceId={serviceId} />
      <Button text="終了したメンテナンスを見る" path={`/archive/maint/${serviceId}/`} />
    </Section>
  );
};

export default MaintenanceSchedule;
